import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BrandMark from "./BrandMark";

/**
 * Global footer shown across all pages. Includes brand line, source
 * attribution, and legal links (Terms / Privacy) — required for
 * production launch (privacy law + GDPR + app-store review).
 */
export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border/60 py-6 mt-auto" data-testid="global-footer">
      <div className="mx-auto max-w-7xl px-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <p className="text-center sm:text-right">
          {t("footer_extra.sefaria_attribution_pre")}{" "}
          <a
            href="https://www.sefaria.org"
            target="_blank"
            rel="noreferrer"
            className="text-gold hover:underline"
          >
            Sefaria
          </a>{" "}
          {t("footer_extra.sefaria_attribution_post")}
        </p>

        <nav className="flex items-center gap-4 flex-wrap justify-center" aria-label={t("footer_extra.links_aria")}>
          <Link
            to="/terms"
            data-testid="footer-link-terms"
            className="hover:text-gold transition-colors"
          >
            {t("footer.terms")}
          </Link>
          <span className="opacity-30">·</span>
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="hover:text-gold transition-colors"
          >
            {t("footer.privacy")}
          </Link>
          <span className="opacity-30">·</span>
          <a
            href="mailto:7torahya@gmail.com"
            data-testid="footer-link-contact"
            className="hover:text-gold transition-colors"
          >
            {t("footer.contact")}
          </a>
          <span className="opacity-30">·</span>
          <Link
            to="/donate"
            data-testid="footer-link-donate"
            className="hover:text-gold transition-colors"
          >
            {t("nav.donate")}
          </Link>
        </nav>

        <Link
          to="/"
          className="flex items-center gap-2 hover:text-gold transition-colors"
          data-testid="footer-brand"
        >
          <BrandMark size={24} className="rounded shrink-0 opacity-90" />
          <span className="font-latin italic">{t("app.name_full")}</span>
        </Link>
      </div>
    </footer>
  );
}
